import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Pagination, CircularProgress, Button } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';

import { Delete, Cancel } from '@mui/icons-material';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import ConfirmationModal from '../../../components/Modal';
import TDataGrid from '../../../components/Datagrid/Datagrid';
import { columns as Columns } from './constants/table_columns_data';
import service from './service';
import { useBoundStore } from '../../../stores';
import Barcode from 'react-barcode';
import { useRef } from 'react';
import domtoimage from 'dom-to-image';
import { InputAdornment, TextField } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  gap: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  borderRadius: 4,
  '&:focus': {
    outline: 'none',
  },
};

const Devices = () => {
  const textPool = useBoundStore((state) => state.textPool);
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const location = useLocation();
  const barcodeRef = useRef(null);

  const [filterData, setFilterData] = useState({ param: '' });
  const [sortModel, setSortModel] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [count, setCount] = useState(0);
  const [deleteItem, setDeleteItem] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [relOpen, setRelOpen] = useState(false);
  const [row, setRow] = useState({});
  const [relation, setRelation] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [barcodeOpen, setBarcodeOpen] = useState(false);

  const paginationChange = (_, e_page) => setPage(e_page - 1);

  const handleDelete = async (row) => {
    setRow(row);
    setOpen(true);
  };

  const handleRelation = async (row) => {
    setRow(row);
    getDeviceVehicleRelation(row.device_Id);
    setRelOpen(true);
  };

  const handleBarcode = async (row) => {
    setRow(row);
    setBarcodeOpen(true);
  };

  const handleDownload = async (ref, barcodeNumber) => {
    console.log(ref);
    domtoimage
      .toJpeg(ref.current, { quality: 0.95 })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = `${barcodeNumber}.jpeg`;
        link.href = dataUrl;
        link.click();
      });

  };

  const columns = Columns(handleDelete, handleRelation, handleBarcode);

  const deleteDevice = async () => {
    const result = await service.deleteDevice({
      id: row.id,
    });
    if (result?.status === 200 || result?.status === 204) {
      setOpen(false);
      toast.success('Cihaz başarıyla silindi.');
      getData();
    } else {
      setOpen(false);
      toast.error('Cihaz silinirken bir hata oluştu.');
    }
  };

  async function getData() {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    const params = {
      ...filterData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getDevicesWithSearch(params);
    const data = result?.data?.content;
    setCount(result?.data?.totalPages);
    setDevices(data);
    setIsLoading(false);
  }

  useEffect(() => {
    setPage(0);
    getData();
  }, [filterData]);

  const filter = async () => {
    setPage(0);
    getData();
  };

  const handleFilterInput = (value) => {
    setFilterData({ ...filterData, param: value });
  };

  useEffect(() => {
    getData();
  }, [page, sortModel, location]);

  return (
    <div className="p-3 m-3 flex flex-col justify-center items-center">
      <div className="w-max   max-lg:w-full p-3 m-3">
        <div className=" py-3 px-2 mx-3 my-2 flex flex-wrap justify-between max-md:justify-center gap-3 items-center">
          <span className="text-lg sm:text-2xl max-sm:text-center">
            {textPool['Cihazlar']}
          </span>
          <div className="mx-2 my-5 flex justify-between items-center">
            <div className="flex max-md:flex-wrap max-md:justify-center gap-2">
              <TextField
                size="small"
                placeholder="Arama"
                onChange={(e) => handleFilterInput(e.target.value)}
                value={filterData.param}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MATERIEL_ICONS.Search />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: '8px',
                  },
                }}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Add />}
                onClick={() => toggleRightDrawer()}
                className="mx-2"
              >
                CİHAZ EKLE
              </Button>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center w-[780px]">
            <CircularProgress className="users-list-circular-progress" />
          </div>
        ) : (
          <div className="w-max max-lg:w-full bg-white rounded-xl shadow-xl p-3 m-3">
            <TDataGrid
              rows={devices}
              columns={columns}
              sortModel={sortModel}
              setSortModel={setSortModel}
            />
            <div className="flex justify-center items-center p-3 m-3">
              <Pagination
                page={page + 1}
                onChange={paginationChange}
                count={count}
                color="primary"
                size="small"
              />
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        img="warning"
        open={open}
        handleClose={() => setOpen(false)}
        title={`${row?.imei} IMEI kodlu cihazı silmek üzeresiniz.`}
        onConfirm={deleteDevice}
        confirmText="SİL"
        cancelText="İPTAL"
        confirmStartIcon={<Delete />}
        cancelStartIcon={<Cancel />}
        text="Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?"
      />
      <Modal open={barcodeOpen} onClose={() => setBarcodeOpen(false)}>
        <Box sx={style} id="barcode">
          <div ref={barcodeRef}>
            <Barcode value={row.barcodeNumber} />
          </div>
          <Button
            variant="contained"
            color="primary"
            startIcon={<MATERIEL_ICONS.Download />}
            onClick={() => handleDownload(barcodeRef, row.barcodeNumber)}
          >
            İNDİR
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default Devices;
